import { db } from '../firebase';
import { Base64 } from 'js-base64';
import { MANAGER_ROLE, CO_MANAGER_ROLE, WORKER_ROLE } from '../../utils/constants';
import _ from 'lodash';

export const getAssignedTask = project => {
    return db.ref('subTasks')
        .orderByChild('project')
        .equalTo(project)
        .once('value')
        .then(snapshot => {
            const promiseArray = [];
            snapshot.forEach((child) => {
                promiseArray.push(db.ref().child(`tasks/${child.val().task}`).once('value')
                    .then((task) => {
                        return db.ref().child(`cycles/${task.val().cycle}`).once('value')
                            .then(name => {
                                return db.ref().child(`projects/${task.val().project}`).once('value')
                                    .then(pro => pro.val() && ({
                                        subTaskId: child.key,
                                        subTask: child.val(),
                                        task: task.val(),
                                        cycles: name.val(),
                                        project: pro.val()
                                    }));
                            });
                    }));
            });
            return Promise.all(promiseArray)
                .then((arr) => {
                    return arr.filter((o) => o && o.subTask && o.subTask.assignedTo && o.task.active)
                });
        });
};

export const getAssignedTasks = projects => {
    return Promise.all(projects.map(getAssignedTask))
        .then(assignedSubTasks => assignedSubTasks.reduce((acc, item) => acc.concat(item), []));
};

export const getUsersProjects = email => {
    return Promise.all([
        db.ref(`users/${Base64.encode(email)}/projects/${MANAGER_ROLE}`)
            .once('value')
            .then(snapshot => snapshot.val() || {}),
        db.ref(`users/${Base64.encode(email)}/projects/${WORKER_ROLE}`)
            .once('value')
            .then(snapshot => snapshot.val() || {}),
        db.ref(`users/${Base64.encode(email)}/projects/${CO_MANAGER_ROLE}`)
            .once('value')
            .then(snapshot => snapshot.val() || {})
    ])
        .then(projects => {
            const allProjects = Object.keys(projects[0])
                .concat(Object.keys(projects[2]));
            return allProjects;
        });

};
export const getAllInvolvedUsers = email => {
    return getUsersProjects(email)
        .then(projects => Promise.all(projects.map(projectId => db.ref(`projects/${projectId}/members`).orderByKey()
            .equalTo(Base64.encode(email)).once('value').then(snapshot => Object.assign({}, { [projectId]: Object.values(snapshot.val()) }) || {}))))
};

export const getWorkerTasks = (email) => {
    const encodedEmail = window.btoa(email);
    return db.ref().child('subTasks').orderByChild('assignedTo').equalTo(encodedEmail)
        .once('value')
        .then((snapshot) => {
            const promiseArray = [];
            snapshot.forEach((child) => {
                promiseArray.push(db.ref().child(`tasks/${child.val().task}`).once('value')
                    .then((task) => {
                        return db.ref().child(`cycles/${task.val().cycle}`).once('value')
                            .then(name => {
                                return db.ref().child(`projects/${task.val().project}`).once('value')
                                    .then(pro => pro.val() && ({
                                        subTaskId: child.key,
                                        subTask: child.val(),
                                        task: task.val(),
                                        cycles: name.val(),
                                        project: pro.val()
                                    }));
                            });
                    }));
            });
            return Promise.all(promiseArray)
                .then((arr) => {
                    return arr.filter((o) => o && o.subTask && o.task.active)
                })
        });
};

export const getFieldValue = (collection, id, field) => db.ref(`${collection}/${id}`)
    .once('value')
    .then(snapshot => {
        if(collection === 'cycles') {
            const cycle = snapshot.val();
            if(!cycle) return;
            return {
                label: cycle[field] ? `Cy ${cycle.index + 1} : ${cycle[field]}` : `Cy ${cycle.index + 1}`,
                value: id
            }
        }
        return {
            label: snapshot.val()[field],
            value: id
        }
    });


export const getProjectTitles = projects => Promise.all(projects.map(projectId => getFieldValue('projects', projectId, 'title')));

export const getCycleTitles = cycles => Promise.all(cycles.map(cycleId => getFieldValue('cycles', cycleId, 'title')));

export const getWorkerNames = workers => Promise.all(workers.map(userId => ({ label: Base64.decode(userId), value: userId })));

export const prepareFilters = (tasks) => {
    const tasksArray = Object.keys(tasks).map(projectId => tasks[projectId]);
    const filters = tasksArray.reduce((result, subTask) => {
        result.projects.push(subTask.subTask.project);
        if (subTask.subTask.cycle) {
            result.cycles.push(subTask.subTask.cycle);
        }
        result.workers.push(subTask.subTask.assignedTo);
        return result;
    }, {
            projects: [],
            cycles: [],
            workers: []
        });
    return Promise.all([
        getProjectTitles(_.uniq(filters.projects)),
        getCycleTitles(_.uniq(filters.cycles)),
        getWorkerNames(_.uniq(filters.workers))
    ]);
};

export const getSubTasks = (taskId) => db.ref(`tasks/${taskId}/subTasks`)
    .once('value')
    .then(snapshot => snapshot.val() || {})
    .then(subTasks => Promise.all(Object.keys(subTasks).map(subTaskId => {
        return db.ref(`subTasks/${subTaskId}`)
            .once('value')
            .then(snapshot => {
                const subTask = snapshot.val() || {};
                return ({ [subTaskId]: subTask });
            })
    })))
    .then(subTasks => subTasks.reduce((result, subTask) => Object.assign(result, subTask), {}))

export const getTaskData = (taskId) => db.ref(`tasks/${taskId}`)
    .once('value')
    .then(snapshot => snapshot.val() || {});



// WEBPACK FOOTER //
// ./src/firebase/db/tasks.js